import { makeStyles, Theme } from "@material-ui/core"
import Select from "@material-ui/core/Select"
import FormControl from "@material-ui/core/FormControl"
import FormHelperText from "@material-ui/core/FormHelperText"
import MenuItem from "@material-ui/core/MenuItem"
import React, { Fragment, useState } from "react"
import { AdPlace } from "Types/place"
import { useMaterialFetchAdPlaces } from "Hooks/place"

const useStyles = makeStyles((theme: Theme) => ({
    toolbar: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
    },
    channelSelect: {
        marginRight: 20,
    },
    selectItem: {
        color: "white",
    },
}))
interface ComponentProps {
    onSearch: (id: number) => void,
    channelName?: string,
}

const EnhancerToolBar = (props: ComponentProps) => {
    const classes = useStyles()
    const { onSearch, channelName = "" } = props
    let channelType: string
    switch (channelName) {
        case 'wechat':
            channelType = '微信'
            break
        case 'weibo':
            channelType = '微博'
            break
        case 'species':
            channelType = '果壳自然'
            break
        default:
            channelType = '果壳病人'
    }
    const { places } = useMaterialFetchAdPlaces(channelType)
    const [ status, setStatus ] = useState<string|number>("")
    const handleChange = (e: React.ChangeEvent<{ value: unknown}>) => {
        const id = e.target.value as string
        setStatus(Number(id))
        onSearch(Number(id))
    }
    return (
        <Fragment>
            <FormControl className={classes.channelSelect}>
                <Select
                    autoWidth
                    displayEmpty
                    value={status}
                    onChange={handleChange}
                >
                    <MenuItem value="">
                        <em>请选择</em>
                    </MenuItem>
                    {
                        places.map(({ id, name }: AdPlace) => (
                            <MenuItem key={id} value={ id }>
                                {name}
                            </MenuItem>
                        ))
                    }
                    {
                        (channelName === "weibo" || channelName === 'species' || channelName === 'health') && (
                            <MenuItem key={"draft"} value={-1}>
                                备选列表
                            </MenuItem>
                        )
                    }
                </Select>
                <FormHelperText>请选择位置</FormHelperText>
            </FormControl>
        </Fragment>
    )
}

export default EnhancerToolBar
